<template>
  <div>
    <div v-if="!showLoader" class="sign-in-box-padding">
      <div>
        <div class="row padding-form-headline-text">
          <h2>{{ headerTitle }}</h2>
          <div style="text-align: left">{{ headerSubTitle }}</div>
        </div>
        <div
          class="row justify-content-between"
          style="margin-top: 2rem !important"
        >
        
        </div>
        <div v-if="error" class="error-text">{{ errorMessage }}</div>
        <v-form ref="form" @submit.prevent="userSignIn" lazy-validation>
          <div class="row">
            <div class="col-md-12 no-padding" id="email">
              <v-text-field
                id="LOGIN_EMAIL"
                @keydown.space.prevent
                v-model="email"
                @input="email = removeWhiteSpace($event)"
                label="Email"
                :error-messages="emailErrors"
                style="font-size: 1.6rem"
                solo
                outline
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 no-padding">
              <v-text-field
                id="LOGIN_PASSWORD"
                v-model="password"
                :append-icon="showIcon ? 'visibility' : 'visibility_off'"
                label="Password"
                :type="showIcon ? 'text' : 'password'"
                :error-messages="passwordErrors"
                @click:append="showIcon = !showIcon"
                style="font-size: 1.6rem"
                solo
                outline
              ></v-text-field>
            </div>
          </div>
          <div class="row no-padding">
            <div class="col-6 col-md-6 col-lg-6 col-xl-6 no-padding">
              <div class="row">
                <span>
                  <v-checkbox id="LOGIN_REMEMBER_ME" v-model="checkbox" :ripple="false"></v-checkbox>
                </span>
                <span @click="checkbox = !checkbox" class="stay-signed-in"
                  >Remember Me</span
                >
              </div>
            </div>
            <div class="col-6 col-md-6 col-lg-6 col-xl-6 no-padding">
              <div class="forgot-password">
                <a id="LOGIN_FORGOT_PASSWORD" @click="onForgotPasswordClick">Forgot Password?</a>
              </div>
            </div>
          </div>
          <div class="row" style="padding-bottom: 2rem !important">
            <button class="button-sign-in" id="btn-log-in-cn">Sign in</button>
          </div>
        </v-form>
        <!-- <div
          class="phone-mode"
          style="
            text-align: left;
            font-size: 1.6rem;
            font-weight: 500;
            color: #050505;
          "
        >
          Don't have an account?
          <span @click="goToSignUp" class="signup">Sign Up</span>
        </div> -->
      </div>
    </div>
    <div v-else>
      <img src="@/assets/static_content/loader.svg" />
    </div>
    <div v-if="openPopup">
      <popup-box
        v-on:box-closed="openPopup = false"
        v-on:resend-email="resendEmailForResetPass"
        v-bind="popupBoxProps"
        v-bind:key="check"
      ></popup-box>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
import * as SYSTEM_CONST from "../../globalConstants";
import PopupBox from "../global-components/pop-up-box";
import * as FILTER from "../../filters";
import { PHONE } from "../../globalFunctions";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  /* eslint-disable */
  name: "login",
  components: {
    PopupBox,
  },
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      email,
      minLength: minLength(4),
      maxLength: maxLength(64),
    },
    password: { required, minLength: minLength(8), maxLength: maxLength(12) },
  },
  props: {
    job_id: String,
    search_key: String,
    header_title: String,
    news: String,
    header_subtitle: String,
  },
  data: function () {
    return {
      email: "",
      password: "",
      showIcon: false,
      checkbox: false,
      showLoader: false,
      openPopup: false,
      popupBoxProps: {
        open: false,
        message: SYSTEM_CONST.FORGET_PASSWORD.MESSAGE,
        title: SYSTEM_CONST.FORGET_PASSWORD.TITLE,
        resendMail: true,
      },
      check: 0,
      error: null,
      errorMessage: null,
      headerTitle: this.header_title || "",
      headerSubTitle: this.header_subtitle || "",
      phone: PHONE(),
    };
  },
  methods: {
    removeWhiteSpace(text) {
      return text.replace(/[\s\/]/g, "");
    },
    userSignIn: function () {
      const self = this;
      let rem = 0;
      self.error = null;
      self.errorMessage = null;
      self.$v.$touch();
      if (self.checkbox) {
        rem = 1;
      }

      let user = {
        email: self.email,
        password: self.password,
        remember: rem,
      };
      if (!self.$v.$anyError) {
        let token = JSON.parse(localStorage.getItem("token"));
        if (token) {
          self.openPopup = true;
          self.popupBoxProps = {
            open: true,
            message:
              "Already logged in from another account. You need to log out first.",
            title: SYSTEM_CONST.POPUP.FAILURE_MESSAGE,
            resendMail: false,
            persist: true,
          };
        } else {
          self.$emit("clicked", true);
          self.showLoader = true;
          self.$store
            .dispatch("signIn", JSON.stringify(user))
            .then(function (response) {
              if (response.status === 200 || response.status === 201) {
                switch (response.data.user_type) {
                  case self.$constants.USER_TYPE.CANDIDATE:
                    if (self.job_id) {
                      self.$router
                        .push({
                          name: "topJobView",
                          params: { q: self.job_id },
                        })
                        .catch(function () {});
                    } else if (self.search_key) {
                      self.$router
                        .push({
                          name: "candidateSearchJobs",
                          params: { q: self.search_key },
                        })
                        .catch(function () {});
                    } else if (self.news) {
                      self.$router
                        .push({
                          name: "news",
                          params: { q: self.news },
                        })
                        .catch(function () {});
                    } else {
                      self.$router
                        .push({ name: "candidate" })
                        .catch(function () {});
                    }
                    break;
                  case self.$constants.USER_TYPE.HIRING_MANAGER:
                    self.$router
                      .push({ name: "employer" })
                      .catch(function () {});
                    break;
                  case self.$constants.USER_TYPE.ADMIN:
                    self.$router.push({ name: "admin" }).catch(function () {});
                    break;
                  default:
                    self.$router
                      .push({ name: "landingPage" })
                      .catch(function () {});
                    break;
                }
              } else {
                self.$emit("clicked", false);
                self.showLoader = false;
                self.error = true;
                self.errorMessage = FILTER.FIRST_LETTER_CAPITAL(
                  response.data.message
                );
              }
            })
            .catch(function (err) {
              self.$emit("clicked", false);
              self.showLoader = false;
              self.error = true;
              self.errorMessage = err.message;
            });
        }
      }
    },
    onForgotPasswordClick: function () {
      const self = this;
      self.openPopup = true;
      self.popupBoxProps = {
        open: true,
        message: SYSTEM_CONST.FORGET_PASSWORD.MESSAGE,
        title: SYSTEM_CONST.FORGET_PASSWORD.TITLE,
        resendMail: true,
      };
      self.check++;
    },
    resendEmailForResetPass: function (email) {
      const self = this;
      let data = JSON.stringify({
        email: email,
      });
      self.popupBoxProps.open = false;
      self.check++;
      self
        .$http({
          method: SYSTEM_CONST.METHOD.POST,
          url: SYSTEM_CONST.BASE_URL.FORGOT_PASSWORD_API_URL,
          headers: {
            "content-type": SYSTEM_CONST.HEADERS.TYPE.APPLICATION_JSON,
          },
          data: data,
        })
        .then(function (response) {
          if (response.status === 200) {
            self.showLoader = false;
            self.popupBoxProps.open = true;
            self.popupBoxProps.title = SYSTEM_CONST.POPUP.SUCCESS_MESSAGE;
            self.popupBoxProps.message =
              "A Password reset link has been sent to your email account";
            self.popupBoxProps.resendMail = false;
            self.check++;
          } else {
            self.showLoader = false;
            self.popupBoxProps.open = true;
            self.popupBoxProps.title = SYSTEM_CONST.POPUP.FAILURE_MESSAGE;
            self.popupBoxProps.message =
              "Sorry, we can’t send a password reset link right now. Please try again later or contact us.";
            self.popupBoxProps.resendMail = false;
            self.check++;
          }
        })
        .catch(function (err) {
          self.showLoader = false;
          self.popupBoxProps.open = true;
          self.popupBoxProps.title = err.response.statusText;
          self.popupBoxProps.message = SYSTEM_CONST.RESEND_EMAIL.FAILURE;
          self.popupBoxProps.resendMail = false;
          self.check++;
        });
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.REQUIRED);
      !this.$v.email.email &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.EMAIL_INVALID);
      !this.$v.email.minLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.LENGTH_TOO_SHORT);
      !this.$v.email.maxLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.LENGTH_TOO_LONG);
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.REQUIRED);
      !this.$v.password.minLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_LENGTH);
      !this.$v.password.maxLength &&
        errors.push(SYSTEM_CONST.REQUIRED_MESSAGE.PASSWORD_LENGTH);
      return errors;
    },
  },
};
</script>

<style scoped>
/* .home {
  position: absolute;
  color: white;
  top: 2.0rem;
  left: -9.0rem;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
} */
.error-text {
  margin: 1rem 0;
  text-align: left;
  color: var(--button-delete-color);
}
.log-in {
  border-radius: 0.4rem;
  padding: 0.5rem;
  text-align: center;
  cursor: pointer;
  width: 100%;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.google {
  border: solid 0.2rem #eeeeee;
  background-color: #eeeeee;
}
.facebook {
  border: solid 0.2rem #4267b2;
  background-color: #4267b2;
}
.sign-in-box-padding {
  width: 36.4rem;
}
.signup {
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.5;
  text-align: left;
  color: var(--link-color);
  cursor: pointer;
  margin-left: 0.5rem;
}
.logo {
  position: fixed;
  left: 10vw;
  top: 25vh;
  font-size: 6rem;
  font-weight: bold;
  color: white;
}
.content {
  font-size: 2rem;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 100;
}
@media (max-width: 600px) {
  .sign-in-box-padding {
    width: 100% !important;
    padding: 4.4rem 3rem;
  }
}

/* .check-box {
  color: black !important;
} */
.forgot-password {
  text-align: right;
  padding-top: 2.2rem;
  font-size: 1.2rem;
  color: var(--link-color);
}
.stay-signed-in {
  margin-left: -0.4rem;
  padding-top: 2.2rem;
  font-size: 1.2rem;
  color: #3d4249;
  cursor: pointer;
}
.header-text {
  font-size: 2rem;
  text-align: center;
  font-weight: bold;
  color: #050405;
}
.button-sign-in-loader {
  margin: auto;
  width: 100%;
  height: 3.8rem;
  border-radius: 0.4rem;
  background-color: var(--landing-color);
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
}
.v-input__control > .v-input__slot {
  background-color: red !important;
}
.v-input {
  text-align: right !important;
}
</style>
